var it = Object.defineProperty;
var ot = (f, e, t) => e in f ? it(f, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : f[e] = t;
var n = (f, e, t) => ot(f, typeof e != "symbol" ? e + "" : e, t);
class X {
  constructor(e) {
    n(this, "children", []);
    n(this, "options");
    this.options = e;
  }
  addChild(e) {
    this.children.push(e);
  }
  build() {
    const e = this.createSVGElement();
    for (const t in this.options)
      e.setAttribute(t, this.options[t]);
    for (const t of this.children)
      e.appendChild(t.build());
    return e;
  }
}
class P extends X {
  constructor(t, s, i = {}) {
    super(i);
    n(this, "width");
    n(this, "height");
    n(this, "offsetX", 5);
    n(this, "offsetY", 5);
    this.width = t, this.height = s;
  }
  createSVGElement() {
    const t = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    return t.setAttribute("width", this.width + "mm"), t.setAttribute("height", this.height + "mm"), t.setAttribute("viewBox", -this.offsetX + " " + -this.offsetY + " " + (this.width + this.offsetX * 2) + " " + (this.height + this.offsetY * 2)), t.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink"), t.classList.add("w-full"), t.classList.add("h-full"), t;
  }
}
class v {
  constructor(e, t) {
    n(this, "fillColor", "#b3c4c9");
    n(this, "strokeColor", "#105167");
    n(this, "borderWidth", 3);
    n(this, "arrowOffset", 20);
    n(this, "defaultOffset", 45);
    n(this, "shapeInputSelectors");
    // @ts-ignore
    n(this, "options");
    this.shapeInputSelectors = t, this.loadOptions(e), this.showInputs(), this.setSelectorExtraClasses(!0), this.reorderFieldsInDOM();
  }
  destroy() {
    this.setSelectorExtraClasses(!1);
  }
  getId() {
    return this.constructor.id;
  }
  /**
   * Set input constraints, such as min and max values and update input labels
   */
  setConstraints() {
  }
  /**
   * Draw the shape inside a container with the arrows
   */
  draw() {
    const e = document.createElement("div");
    return e.style.width = "100%", e.style.height = "100%", e.append(this.generateSvg()), e;
  }
  /**
   * Scale the width and height of the shape to fit the element
   * @param width
   * @param height
   * @param elementWidth
   * @param elementHeight
   * @param factor
   * @protected
   */
  getScaledDimensions(e, t, s, i, o = 1) {
    const r = s * o, h = i * o, a = r / e, c = h / t, p = Math.min(a, c), d = e * p, l = t * p;
    return { scaledWidth: d, scaledHeight: l, scaleFactor: p };
  }
  /**
   * Calculate the center of the two given dimension values
   * @param shapeDimensionValue The dimension value of the shape, ex. width or height
   * @param elementDimensionValue The dimension value of the element, ex. width or height
   */
  calculateCenteredPosition(e, t) {
    return (t - e) / 2;
  }
  showInputs() {
    const e = this.constructor.selectors;
    Object.values(this.shapeInputSelectors).filter((t) => !e.includes(t)).forEach((t) => {
      const s = document.querySelector(t), i = s == null ? void 0 : s.closest(".dimension-field-container");
      i == null || i.classList.add("hidden"), t !== this.shapeInputSelectors.Length && t !== this.shapeInputSelectors.Width && (s == null || s.setAttribute("disabled", "disabled"));
    }), e.forEach((t) => {
      const s = document.querySelector(t), i = s == null ? void 0 : s.closest(".dimension-field-container");
      i == null || i.classList.remove("hidden"), t !== this.shapeInputSelectors.Length && t !== this.shapeInputSelectors.Width && (s == null || s.removeAttribute("disabled"));
    });
  }
  setSelectorExtraClasses(e = !0) {
    const t = this.constructor.selectorExtraClasses;
    Object.entries(t).forEach(([s, i]) => {
      const o = document.querySelector(s), r = o == null ? void 0 : o.closest(".dimension-field-container");
      e ? r == null || r.classList.add(...i) : r == null || r.classList.remove(...i);
    });
  }
  reorderFieldsInDOM() {
    const e = this.constructor.selectors, t = document.querySelector("[data-dimension-fields]");
    t && e.forEach((s) => {
      const i = document.querySelector(s), o = i == null ? void 0 : i.closest(".dimension-field-container");
      o && t.appendChild(o);
    });
  }
}
n(v, "selectors", []), n(v, "selectorExtraClasses", {}), n(v, "shapeName", "Vorm"), n(v, "id", "shape"), n(v, "position", 9999);
function w(f, e = 0, t = !1) {
  const s = document.querySelector(f);
  if (!s)
    return e;
  !s.value && t && (s.value = e.toString(), s.dispatchEvent(new Event("input")), s.dispatchEvent(new Event("change")));
  let i = s.value ? parseFloat(s.value) : e;
  return s.min && (i = Math.max(i, parseFloat(s.min))), s.max && (i = Math.min(i, parseFloat(s.max))), i;
}
function nt(f, e = 0) {
  const t = Math.pow(10, e);
  return Math.round(f * t) / t;
}
function _() {
  return Date.now().toString(36) + Math.random().toString(36).substring(2);
}
class R extends X {
  constructor(t, s, i = {}) {
    super(i);
    n(this, "name");
    n(this, "path");
    this.name = t, this.path = s;
  }
  createSVGElement() {
    const t = document.createElementNS("http://www.w3.org/2000/svg", "path");
    return t.setAttribute("d", this.path), t.setAttribute("id", this.name + "-" + _()), t;
  }
}
class Q extends X {
  constructor(t, s, i = {}) {
    super(i);
    n(this, "content");
    n(this, "pathId");
    n(this, "fontSize", 12);
    n(this, "offset", 0);
    this.content = t, this.pathId = s;
  }
  setFontSize(t) {
    this.fontSize = t;
  }
  setOffset(t) {
    this.offset = t;
  }
  createSVGElement() {
    const t = document.createElementNS("http://www.w3.org/2000/svg", "text"), s = document.createElementNS("http://www.w3.org/2000/svg", "textPath");
    return s.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", `#${this.pathId}`), s.setAttribute("startOffset", "50%"), s.setAttribute("text-anchor", "middle"), s.textContent = this.content, t.setAttribute("style", `fill:black;font-size:${this.fontSize}px;`), t.appendChild(s), t.setAttribute("dy", this.offset + (this.fontSize / 2 - 1) + "px"), t;
  }
}
class L {
  constructor(e, t, s, i, o) {
    n(this, "id");
    n(this, "firstX");
    n(this, "firstY");
    n(this, "secondX");
    n(this, "secondY");
    n(this, "topLabel", "");
    n(this, "bottomLabel", "");
    n(this, "arrowWidth", 5);
    n(this, "labelOffset", 20);
    n(this, "fontSize", 12);
    /**
     * The extra margin to show the text outside the arrow
     * @private
     */
    n(this, "textMargin", 100);
    n(this, "minimalLength", 15);
    this.id = e + "-" + _(), this.firstX = t, this.firstY = s, this.secondX = i, this.secondY = o;
  }
  setTopLabel(e) {
    this.topLabel = e;
  }
  setBottomLabel(e) {
    this.bottomLabel = e;
  }
  setArrowWidth(e) {
    this.arrowWidth = e;
  }
  setLabelSpace(e) {
    this.labelOffset = e;
  }
  setFontSize(e) {
    this.fontSize = e;
  }
  setTextMargin(e) {
    this.textMargin = e;
  }
  setMinimalLength(e) {
    this.minimalLength = e;
  }
  addToSvg(e) {
    const t = this.getVector(this.firstX, this.firstY, this.secondX, this.secondY), s = this.getLength(t), { ux: i, uy: o } = this.getUnitVector(t, s), r = (this.firstX + this.secondX) / 2, h = (this.firstY + this.secondY) / 2, a = Math.max(s, this.minimalLength) / 2, c = r - i * a, p = h - o * a, d = r + i * a, l = h + o * a;
    this.drawLabels(e), this.drawDimensionLine(e, c, p, d, l, i, o, a * 2), this.drawArrow(e, "left-arrow", c, p, d, l, "left"), this.drawArrow(e, "right-arrow", c, p, d, l, "right");
  }
  drawLabels(e) {
    if (this.topLabel) {
      const t = new Q(
        this.topLabel,
        this.id
      );
      t.setFontSize(this.fontSize), t.setOffset(-this.labelOffset), e.addChild(t);
    }
    if (this.bottomLabel) {
      const t = new Q(
        this.bottomLabel,
        this.id
      );
      t.setFontSize(this.fontSize), t.setOffset(this.labelOffset), e.addChild(t);
    }
  }
  drawDimensionLine(e, t, s, i, o, r, h, a) {
    const c = t - r * this.textMargin, p = s - h * this.textMargin, d = i + r * this.textMargin, l = o + h * this.textMargin;
    e.addChild(new R(
      "dimension-line",
      `M${c} ${p} L${d} ${l}`,
      {
        id: this.id,
        style: "stroke:#0e3340;stroke-width:.3%;",
        "stroke-dasharray": `0 ${this.textMargin} ${a} ${this.textMargin}`
      }
    ));
  }
  drawArrow(e, t, s, i, o, r, h) {
    const a = this.getVector(s, i, o, r), c = this.getLength(a), { ux: p, uy: d } = this.getUnitVector(a, c), { perpX: l, perpY: u } = this.getPerpendicular(p, d), g = h === "left" ? s : o, x = h === "left" ? i : r, m = g - (h === "left" ? -p : p) * this.arrowWidth, b = x - (h === "left" ? -d : d) * this.arrowWidth, E = m + l * this.arrowWidth, H = b + u * this.arrowWidth, O = m - l * this.arrowWidth, A = b - u * this.arrowWidth, B = `M${E} ${H} L${g} ${x} L${O} ${A}`;
    e.addChild(new R(
      t,
      B,
      {
        style: "stroke:#0e3340;stroke-width:.3%;fill:none;stroke-linejoin:round;stroke-linecap:round;"
      }
    ));
  }
  getVector(e, t, s, i) {
    return { dx: s - e, dy: i - t };
  }
  getLength(e) {
    return Math.sqrt(e.dx * e.dx + e.dy * e.dy);
  }
  getUnitVector(e, t) {
    return {
      ux: e.dx / (t || 1),
      uy: e.dy / (t || 1)
    };
  }
  getPerpendicular(e, t) {
    return {
      perpX: -t,
      perpY: e
    };
  }
  static preventLabelOverlap(e, t, s, i, o, r, h, a = 20, c = 12) {
    const p = (u, g, x) => {
      const m = x.length * c * 0.5;
      return {
        left: u - m / 2,
        right: u + m / 2,
        top: h + g - c,
        bottom: h + g
      };
    }, d = p(o, a, t), l = p(r, a, i);
    if (e.setLabelSpace(a), s.setLabelSpace(a), this.boxesOverlap(d, l)) {
      const u = a + c;
      s.setLabelSpace(u);
    }
  }
  static boxesOverlap(e, t) {
    return !(e.right < t.left || e.left > t.right || e.bottom < t.top || e.top > t.bottom);
  }
}
const k = class k extends v {
  loadOptions(e) {
    k.selectors = [
      this.shapeInputSelectors.Height,
      this.shapeInputSelectors.Width
    ];
    const t = w(this.shapeInputSelectors.Height, 50, e.fillDefaultValues), s = w(this.shapeInputSelectors.Width, 50, e.fillDefaultValues);
    this.options = {
      width: s,
      height: t,
      ...e
    };
  }
  generateSvg() {
    const e = this.defaultOffset, t = this.defaultOffset, s = this.options.elementWidth - e, i = this.options.elementHeight - t, {
      scaledWidth: o,
      scaledHeight: r
    } = this.getScaledDimensions(this.options.width, this.options.height, s, i), h = this.calculateCenteredPosition(o, s) + e, a = this.calculateCenteredPosition(r, i), c = new P(this.options.elementWidth, this.options.elementHeight);
    c.addChild(new R(
      "rectangle",
      "M" + h + " " + a + " L" + h + " " + (a + r) + " L" + (h + o) + " " + (a + r) + " L" + (h + o) + " " + a + " Z",
      {
        style: "fill:" + this.fillColor + ";stroke:" + this.strokeColor + ";stroke-width:." + this.borderWidth + "%;stroke-location:inside;",
        "vector-effect": "non-scaling-stroke"
      }
    ));
    const p = a + r + this.arrowOffset, d = this.options.width.toString().replace(".", ","), l = this.options.height.toString().replace(".", ","), u = new L(
      "width-dimension-line",
      h,
      p,
      h + o,
      p
    );
    u.setBottomLabel("Breedte: " + d + " " + this.options.inputUnit), u.addToSvg(c);
    const g = new L(
      "height-dimension-line",
      h - this.arrowOffset,
      a + r,
      h - this.arrowOffset,
      a
    );
    return g.setTopLabel("Hoogte: " + l + " " + this.options.inputUnit), g.addToSvg(c), c.build();
  }
  getDimensionsValueLabel() {
    return this.options.width + "x" + this.options.height + this.options.inputUnit;
  }
};
n(k, "selectors", []), n(k, "selectorExtraClasses", {}), n(k, "shapeName", "Rechthoek"), n(k, "id", "rectangle"), n(k, "position", 1);
let Y = k;
const S = class S {
};
n(S, "CM", "cm"), n(S, "MM", "mm"), n(S, "M", "m"), n(S, "convertUnitValue", function(e, t, s) {
  return e = S.convertFloat(e), t === s ? e : Math.floor(e * S.getConversionValue(t)) / S.getConversionValue(s);
}), n(S, "getConversionValue", function(e) {
  switch (e) {
    case S.MM:
      return 1;
    case S.CM:
      return 10;
    case S.M:
    default:
      return 1e3;
  }
}), n(S, "convertFloat", function(e) {
  if (typeof e == "string") {
    let t = e.match(/^([0-9]+)[\,|\.]([0-9]{0,2})$/);
    t && (e = t[1] + "." + t[2]);
  }
  return parseFloat(e);
});
let W = S;
const y = class y extends v {
  loadOptions(e) {
    y.selectors = [
      this.shapeInputSelectors.Height,
      this.shapeInputSelectors.Width,
      this.shapeInputSelectors.RadiusTopLeft,
      this.shapeInputSelectors.RadiusTopRight,
      this.shapeInputSelectors.RadiusBottomLeft,
      this.shapeInputSelectors.RadiusBottomRight
    ];
    const t = w(this.shapeInputSelectors.Height, 50, e.fillDefaultValues), s = w(this.shapeInputSelectors.Width, 50, e.fillDefaultValues), i = w(this.shapeInputSelectors.RadiusTopLeft, 1, e.fillDefaultValues), o = w(this.shapeInputSelectors.RadiusTopRight, 1, e.fillDefaultValues), r = w(this.shapeInputSelectors.RadiusBottomLeft, 1, e.fillDefaultValues), h = w(this.shapeInputSelectors.RadiusBottomRight, 1, e.fillDefaultValues);
    this.options = {
      width: s,
      height: t,
      radiusTopLeft: i,
      radiusTopRight: o,
      radiusBottomLeft: r,
      radiusBottomRight: h,
      ...e
    };
  }
  generateSvg() {
    const e = this.defaultOffset, t = this.defaultOffset, s = this.options.elementWidth - e, i = this.options.elementHeight - t, {
      scaledWidth: o,
      scaledHeight: r
    } = this.getScaledDimensions(this.options.width, this.options.height, s, i), h = this.calculateCenteredPosition(o, s) + e, a = this.calculateCenteredPosition(r, i), c = new P(this.options.elementWidth, this.options.elementHeight), {
      radiusTopLeftScaled: p,
      radiusTopRightScaled: d,
      radiusBottomLeftScaled: l,
      radiusBottomRightScaled: u
    } = this.getScaledRadius(o / this.options.width);
    c.addChild(new R(
      "rectangle",
      "M" + (h + p) + " " + a + " H" + (h + o - d) + " A" + d + " " + d + " 0 0 1 " + (h + o) + " " + (a + d) + " V" + (a + r - u) + " A" + u + " " + u + " 0 0 1 " + (h + o - u) + " " + (a + r) + " H" + (h + l) + " A" + l + " " + l + " 0 0 1 " + h + " " + (a + r - l) + " V" + (a + p) + " A" + p + " " + p + " 0 0 1 " + (h + p) + " " + a + " Z",
      {
        style: "fill:" + this.fillColor + ";stroke:" + this.strokeColor + ";stroke-width:." + this.borderWidth + "%;stroke-location:inside;",
        "vector-effect": "non-scaling-stroke"
      }
    ));
    const g = a + r + this.arrowOffset, x = this.options.width.toString().replace(".", ","), m = this.options.height.toString().replace(".", ","), b = new L(
      "width-dimension-line",
      h,
      g,
      h + o,
      g
    );
    b.setBottomLabel("Breedte: " + x + " " + this.options.inputUnit), b.addToSvg(c);
    const E = new L(
      "height-dimension-line",
      h - this.arrowOffset,
      a + r,
      h - this.arrowOffset,
      a
    );
    return E.setTopLabel("Hoogte: " + m + " " + this.options.inputUnit), E.addToSvg(c), c.build();
  }
  /**
   * @param scaleFactor the factor to scale the radius
   * @private
   */
  getScaledRadius(e = 1) {
    const t = this.getRadiusMaxSize(), s = Math.min(this.options.radiusTopLeft, t), i = Math.min(this.options.radiusTopRight, t), o = Math.min(this.options.radiusBottomLeft, t), r = Math.min(this.options.radiusBottomRight, t), h = s * e, a = i * e, c = o * e, p = r * e;
    return { radiusTopLeftScaled: h, radiusTopRightScaled: a, radiusBottomLeftScaled: c, radiusBottomRightScaled: p };
  }
  getRadiusMaxSize() {
    const e = W.convertUnitValue(
      this.options.width,
      this.options.inputUnit,
      W.MM
    ), t = W.convertUnitValue(
      this.options.height,
      this.options.inputUnit,
      W.MM
    ), s = Math.floor(Math.min(e, t) / 2);
    return W.convertUnitValue(
      s,
      W.MM,
      this.options.inputUnit
    );
  }
  getDimensionsValueLabel() {
    const e = [
      Math.max(this.options.radiusTopLeft, 0) + this.options.inputUnit,
      Math.max(this.options.radiusTopRight, 0) + this.options.inputUnit,
      Math.max(this.options.radiusBottomLeft, 0) + this.options.inputUnit,
      Math.max(this.options.radiusBottomRight, 0) + this.options.inputUnit
    ].join("/");
    return this.options.width + "x" + this.options.height + this.options.inputUnit + " " + e;
  }
  setConstraints() {
    const e = this.getRadiusMaxSize();
    [
      this.shapeInputSelectors.RadiusTopLeft,
      this.shapeInputSelectors.RadiusTopRight,
      this.shapeInputSelectors.RadiusBottomLeft,
      this.shapeInputSelectors.RadiusBottomRight
    ].forEach((s) => {
      const i = document.querySelector(s);
      i.setAttribute("max", e.toString());
      const o = document.querySelector('label[for="' + i.id + '"] span');
      o && (o.innerText = " (max. " + e + " " + this.options.inputUnit + ")");
    });
  }
};
n(y, "selectors", []), n(y, "selectorExtraClasses", {}), n(y, "shapeName", "Afgeronde rechthoek"), n(y, "id", "rectangle-rounded"), n(y, "position", 2);
let D = y;
const I = class I extends v {
  loadOptions(e) {
    I.selectors = [
      this.shapeInputSelectors.HeightLeft,
      this.shapeInputSelectors.HeightRight,
      this.shapeInputSelectors.Width
    ], I.selectorExtraClasses = {
      [this.shapeInputSelectors.HeightLeft]: ["lg:col-span-1", "col-span-2"],
      [this.shapeInputSelectors.HeightRight]: ["lg:col-span-1", "col-span-2"],
      [this.shapeInputSelectors.Width]: ["col-span-2"]
    };
    const t = w(this.shapeInputSelectors.Width, 50, e.fillDefaultValues), s = w(this.shapeInputSelectors.HeightLeft, 40, e.fillDefaultValues), i = w(this.shapeInputSelectors.HeightRight, 25, e.fillDefaultValues);
    this.options = {
      width: t,
      heightLeft: s,
      heightRight: i,
      ...e
    };
  }
  generateSvg() {
    const e = this.defaultOffset, t = this.defaultOffset, s = this.defaultOffset, i = this.options.elementWidth - e - t, o = this.options.elementHeight - s, r = Math.max(this.options.heightLeft, this.options.heightRight), {
      scaledWidth: h,
      scaledHeight: a,
      scaleFactor: c
    } = this.getScaledDimensions(this.options.width, r, i, o), p = this.options.heightLeft * c, d = this.options.heightRight * c, l = this.calculateCenteredPosition(h, i) + e, u = this.calculateCenteredPosition(a, o), g = a - p + u, x = a - d + u, m = new P(this.options.elementWidth, this.options.elementHeight);
    m.addChild(new R(
      "rectangle",
      "M" + l + " " + g + " L" + l + " " + (u + a) + " L" + (l + h) + " " + (u + a) + " L" + (l + h) + " " + x + " Z",
      {
        style: "fill:" + this.fillColor + ";stroke:" + this.strokeColor + ";stroke-width:." + this.borderWidth + "%;stroke-location:inside;",
        "vector-effect": "non-scaling-stroke"
      }
    ));
    const b = u + a + this.arrowOffset, E = this.options.width.toString().replace(".", ","), H = this.options.heightLeft.toString().replace(".", ","), O = this.options.heightRight.toString().replace(".", ","), A = new L(
      "width-dimension-line",
      l,
      b,
      l + h,
      b
    );
    A.setBottomLabel("Breedte: " + E + " " + this.options.inputUnit), A.addToSvg(m);
    const B = new L(
      "height-left-dimension-line",
      l - this.arrowOffset,
      u + a,
      l - this.arrowOffset,
      u + (a - p)
    );
    B.setTopLabel("Hoogte: " + H + " " + this.options.inputUnit), B.addToSvg(m);
    const T = new L(
      "height-right-dimension-line",
      l + h + this.arrowOffset,
      u + a,
      l + h + this.arrowOffset,
      u + (a - d)
    );
    return T.setBottomLabel("Hoogte: " + O + " " + this.options.inputUnit), T.addToSvg(m), m.build();
  }
  getDimensionsValueLabel() {
    return this.options.width + "x" + this.options.heightLeft + "/" + this.options.heightRight + this.options.inputUnit;
  }
};
n(I, "selectors", []), n(I, "selectorExtraClasses", {}), n(I, "shapeName", "Schuine rechthoek"), n(I, "id", "rectangle-slanted-side"), n(I, "position", 5);
let V = I, ht = class extends X {
  constructor(t, s, i, o = {}) {
    super(o);
    n(this, "x");
    n(this, "y");
    n(this, "radius");
    this.x = t, this.y = s, this.radius = i;
  }
  createSVGElement() {
    const t = document.createElementNS("http://www.w3.org/2000/svg", "circle");
    return t.setAttribute("cx", this.x.toString()), t.setAttribute("cy", this.y.toString()), t.setAttribute("r", this.radius.toString()), t;
  }
};
const C = class C extends v {
  loadOptions(e) {
    C.selectors = [
      this.shapeInputSelectors.Diameter
    ], C.selectorExtraClasses = {
      [this.shapeInputSelectors.Diameter]: ["col-span-2"]
    };
    const t = w(this.shapeInputSelectors.Diameter, 50, e.fillDefaultValues);
    this.options = {
      diameter: t,
      ...e
    };
  }
  generateSvg() {
    const e = this.defaultOffset, t = this.options.elementWidth, s = this.options.elementHeight - e, {
      scaledWidth: i,
      scaledHeight: o
    } = this.getScaledDimensions(this.options.diameter, this.options.diameter, t, s), r = i / 2, h = this.calculateCenteredPosition(i, t), a = this.calculateCenteredPosition(o, s), c = new P(this.options.elementWidth, this.options.elementHeight);
    c.addChild(new ht(
      h + r,
      a + r,
      r,
      {
        style: "fill:" + this.fillColor + ";stroke:" + this.strokeColor + ";stroke-width:." + this.borderWidth + "%;stroke-location:inside;",
        "vector-effect": "non-scaling-stroke"
      }
    ));
    const p = a + o + this.arrowOffset, d = this.options.diameter.toString().replace(".", ","), l = new L(
      "diameter-dimension-line",
      h,
      p,
      h + i,
      p
    );
    return l.setBottomLabel("Diameter: " + d + " " + this.options.inputUnit), l.addToSvg(c), c.build();
  }
  getDimensionsValueLabel() {
    return this.options.diameter + this.options.inputUnit;
  }
};
n(C, "selectors", []), n(C, "selectorExtraClasses", {}), n(C, "shapeName", "Cirkel"), n(C, "id", "circle"), n(C, "position", 3);
let q = C;
const M = class M extends v {
  loadOptions(e) {
    M.selectors = [
      this.shapeInputSelectors.WidthLeft,
      this.shapeInputSelectors.WidthRight,
      this.shapeInputSelectors.Height
    ], M.selectorExtraClasses = {
      [this.shapeInputSelectors.WidthLeft]: ["lg:col-span-1", "col-span-2"],
      [this.shapeInputSelectors.WidthRight]: ["lg:col-span-1", "col-span-2"],
      [this.shapeInputSelectors.Height]: ["col-span-2"]
    };
    const t = w(this.shapeInputSelectors.Height, 50, e.fillDefaultValues), s = w(this.shapeInputSelectors.WidthLeft, 25, e.fillDefaultValues), i = w(this.shapeInputSelectors.WidthRight, 25, e.fillDefaultValues);
    this.options = {
      height: t,
      widthLeft: s,
      widthRight: i,
      ...e
    };
  }
  generateSvg() {
    var J, K;
    const e = this.defaultOffset, t = this.defaultOffset * 2 + this.arrowOffset, s = 3, i = this.options.elementWidth - e, o = this.options.elementHeight - t, r = this.options.widthLeft + this.options.widthRight, {
      scaledWidth: h,
      scaledHeight: a
    } = this.getScaledDimensions(r, this.options.height, i, o), c = h * (this.options.widthLeft / r), p = h * (this.options.widthRight / r), d = this.calculateCenteredPosition(h, i) + e, l = this.calculateCenteredPosition(a, o), u = new P(this.options.elementWidth, this.options.elementHeight);
    u.addChild(new R(
      "triangle",
      "M" + (d + c) + " " + l + " L" + d + " " + (l + a) + " L" + (d + h) + " " + (l + a) + " Z",
      {
        style: "fill:" + this.fillColor
      }
    )), u.addChild(new R(
      "triangle-dash-middle",
      "M" + (d + c) + " " + (l + this.borderWidth) + " L" + (d + c) + " " + (l + this.borderWidth + a - this.borderWidth * 2) + " Z",
      {
        style: "stroke:#0E3340;stroke-width:." + this.borderWidth + "%;stroke-location:inside;",
        "vector-effect": "non-scaling-stroke",
        "stroke-dasharray": "5 7"
      }
    )), u.addChild(new R(
      "triangle",
      "M" + (d + c) + " " + l + " L" + d + " " + (l + a) + " L" + (d + h) + " " + (l + a) + " Z",
      {
        style: "fill:transparent;stroke:" + this.strokeColor + ";stroke-width:." + this.borderWidth + "%;stroke-location:inside;",
        "vector-effect": "non-scaling-stroke"
      }
    ));
    const g = l + a + this.arrowOffset, x = g + 45 + this.arrowOffset, m = Math.max(
      ((J = this.options.widthLeft.toString().split(".")[1]) == null ? void 0 : J.length) || 0,
      ((K = this.options.widthRight.toString().split(".")[1]) == null ? void 0 : K.length) || 0
    ), b = nt(r, m).toString().replace(".", ","), E = this.options.widthLeft.toString().replace(".", ","), H = this.options.widthRight.toString().replace(".", ","), O = this.options.height.toString().replace(".", ","), A = d - 2, B = d + c - s / 2, T = d + c + s / 2, F = d + c + p + 2, tt = (A + B) / 2, et = (T + F) / 2, st = g, N = "Breedte: " + E + " " + this.options.inputUnit, z = "Breedte: " + H + " " + this.options.inputUnit, $ = new L(
      "width-left-dimension-line",
      A,
      g,
      B,
      g
    );
    $.setBottomLabel(N);
    const Z = new L(
      "width-right-dimension-line",
      T,
      g,
      F,
      g
    );
    Z.setBottomLabel(z), L.preventLabelOverlap(
      $,
      N,
      Z,
      z,
      tt,
      et,
      st
    ), $.addToSvg(u), Z.addToSvg(u);
    const j = new L(
      "width-dimension-line",
      d,
      x,
      d + h,
      x
    );
    j.setBottomLabel("Breedte: " + b + " " + this.options.inputUnit), j.addToSvg(u);
    const G = new L(
      "height-dimension-line",
      d - this.arrowOffset,
      l + a,
      d - this.arrowOffset,
      l
    );
    return G.setTopLabel("Hoogte: " + O + " " + this.options.inputUnit), G.addToSvg(u), u.build();
  }
  getDimensionsValueLabel() {
    return this.options.widthLeft + "/" + this.options.widthRight + "x" + this.options.height + this.options.inputUnit;
  }
  setConstraints() {
    const e = document.querySelector(this.shapeInputSelectors.Width), t = parseFloat(e.max), s = document.querySelector(this.shapeInputSelectors.WidthLeft), i = document.querySelector(this.shapeInputSelectors.WidthRight), o = Math.floor(t - (i.value === "" ? 0 : this.options.widthRight)), r = Math.floor(t - (s.value === "" ? 0 : this.options.widthLeft));
    s.setAttribute("max", o.toString()), i.setAttribute("max", r.toString());
    const h = document.querySelector('label[for="' + s.id + '"] span');
    h && (h.innerText = " (max. " + o + " " + this.options.inputUnit + ")");
    const a = document.querySelector('label[for="' + i.id + '"] span');
    a && (a.innerText = " (max. " + r + " " + this.options.inputUnit + ")");
  }
};
n(M, "selectors", []), n(M, "selectorExtraClasses", {}), n(M, "shapeName", "Driehoek"), n(M, "id", "triangle"), n(M, "position", 4);
let U = M;
const at = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Circle: q,
  Rectangle: Y,
  RectangleRounded: D,
  RectangleSlantedSide: V,
  Triangle: U
}, Symbol.toStringTag, { value: "Module" }));
class ct {
  constructor(e) {
    n(this, "options");
    n(this, "element");
    n(this, "thumbnailInput");
    n(this, "selectedShapeInput");
    n(this, "requestedShape");
    n(this, "shapeButtonsContainerSelector");
    n(this, "currentShape");
    n(this, "allowedShapes", []);
    this.options = {
      elementId: "plexi-designer-ts",
      // @ts-ignore
      shapeInputSelectors: {
        Length: "[data-product-length]",
        Width: "[data-product-width]",
        RadiusTopLeft: "[data-product-radius-top-left]",
        RadiusTopRight: "[data-product-radius-top-right]",
        RadiusBottomLeft: "[data-product-radius-bottom-left]",
        RadiusBottomRight: "[data-product-radius-bottom-right]",
        Diameter: "[data-product-diameter]",
        WidthLeft: "[data-product-width-left]",
        WidthRight: "[data-product-width-right]",
        Height: "[data-product-height]",
        HeightLeft: "[data-product-height-left]",
        HeightRight: "[data-product-height-right]"
      },
      ...e
    };
    let t = Object.values(at);
    this.options.allowedShapes && this.options.allowedShapes.length > 0 && (t = t.filter((r) => this.options.allowedShapes.includes(r.id))), t = t.sort((r, h) => r.position - h.position), this.allowedShapes = t;
    const s = this.options.elementId ? document.getElementById(this.options.elementId) : null;
    if (!s)
      throw new Error(`Element with id "${this.options.elementId}" not found`);
    this.element = s;
    let i = null;
    if (this.options.selectedShapeInputSelector && (i = document.querySelector(this.options.selectedShapeInputSelector)), !i)
      throw new Error(`Element selected by "${this.options.selectedShapeInputSelector}" not found`);
    let o = null;
    if (this.options.thumbnailInputSelector && (o = document.querySelector(this.options.thumbnailInputSelector)), !o)
      throw new Error(`Element selected by "${this.options.thumbnailInputSelector}" not found`);
    this.selectedShapeInput = i, this.thumbnailInput = o, this.setRequestedShape(this.options.initialShape || this.element.dataset.productShape), this.shapeButtonsContainerSelector = this.options.shapeButtonsContainer, Object.values(this.options.shapeInputSelectors || {}).forEach((r) => {
      document.querySelectorAll(r).forEach((h) => {
        h.addEventListener("input", (a) => {
          const c = a.target, p = a.composedPath ? a.composedPath()[0] : a.target, d = c.offsetParent === null, l = !(p instanceof HTMLElement) || p.dataset.dimensionField === void 0;
          !d && !l && this.drawShape(), this.fillMainDimensionInput(r);
        });
      });
    }), this.generateButtons(), this.drawShape(!0), this.insertShapeIcons();
  }
  setRequestedShape(e) {
    if (this.allowedShapes.length === 0)
      throw new Error("No allowed shapes defined");
    if (this.allowedShapes.find((t) => t.id === e) === void 0) {
      this.requestedShape = this.allowedShapes[0].id;
      return;
    }
    this.requestedShape = e;
  }
  drawShape(e = !1) {
    var i, o;
    const t = {
      inputUnit: this.element.dataset.inputUnit || "",
      elementWidth: this.element.offsetWidth,
      elementHeight: this.element.offsetHeight,
      fillDefaultValues: e
    };
    if (this.selectedShapeInput && this.selectedShapeInput.value != (this.requestedShape || "") && (this.selectedShapeInput.value = this.requestedShape || "", this.selectedShapeInput.dispatchEvent(new Event("input")), this.selectedShapeInput.dispatchEvent(new Event("change"))), this.currentShape && this.currentShape.getId() === this.requestedShape) {
      this.currentShape.loadOptions(t), this.drawSvg(), this.currentShape.setConstraints();
      return;
    }
    (i = this.currentShape) == null || i.destroy();
    let s;
    switch (this.requestedShape) {
      case D.id: {
        s = D;
        break;
      }
      case V.id: {
        s = V;
        break;
      }
      case q.id: {
        s = q;
        break;
      }
      case U.id: {
        s = U;
        break;
      }
      default: {
        s = Y;
        break;
      }
    }
    this.currentShape = new s(t, this.options.shapeInputSelectors), document.dispatchEvent(new CustomEvent("plexi-designer:select-shape", {
      detail: {
        source: this.selectedShapeInput
      }
    })), this.drawSvg(), (o = this.currentShape) == null || o.setConstraints();
  }
  drawSvg() {
    var i;
    if (!this.currentShape)
      throw new Error("Current shape is not defined");
    const e = this.currentShape.draw();
    this.element.innerHTML = "", this.element.appendChild(e), this.thumbnailInput && (this.thumbnailInput.value = encodeURIComponent(e.outerHTML), this.thumbnailInput.dispatchEvent(new Event("input")), this.thumbnailInput.dispatchEvent(new Event("change"))), (i = this.options.cloneSvgTo) == null || i.forEach((o) => {
      document.querySelectorAll(o).forEach((h) => {
        h instanceof HTMLElement && (h.innerHTML = "", h.appendChild(e.cloneNode(!0)));
      });
    });
    const t = document.querySelector(".product-options-row:has([data-dimension-fields])"), s = t == null ? void 0 : t.querySelector("[data-current-value]");
    s && (s.innerHTML = "(" + this.currentShape.getDimensionsValueLabel() + ")");
  }
  generateButtons() {
    if (!this.shapeButtonsContainerSelector)
      return;
    document.querySelectorAll(this.shapeButtonsContainerSelector).forEach((t) => {
      this.allowedShapes.map((i) => {
        var r;
        const o = document.createElement("button");
        return o.classList.add("plexi-shape"), this.options.shapeButtonClasses && o.classList.add(...this.options.shapeButtonClasses), i.id === this.requestedShape && o.classList.add("active"), o.dataset.shape = i.id, o.dataset.title = i.shapeName, o.onclick = () => {
          let h = !1;
          this.requestedShape !== i.id && (this.setRequestedShape(i.id), this.clearInputValues(), h = !0), this.drawShape(h), this.updateURLWithInputValues(o), this.updateLinksWithInputValues(o), t.querySelectorAll(".plexi-shape").forEach((a) => {
            a.classList.remove("active");
          }), o.classList.add("active");
        }, o.innerHTML = '<svg class="' + ((r = this.options.shapeButtonSvgClasses) == null ? void 0 : r.join(" ")) + `"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#plexi-designer-${i.id}"></use></svg>`, o;
      }).forEach((i) => {
        t.appendChild(i);
      });
    });
  }
  updateURLWithInputValues(e) {
    if (!this.options.updateUrl)
      return;
    const t = e.dataset.shape, s = new URL(window.location.href);
    s.searchParams.set("vorm", t || ""), history.pushState(null, "", s);
  }
  updateLinksWithInputValues(e) {
    const t = e.dataset.shape;
    if (t === "")
      return;
    const s = document.getElementsByClassName("product-options-row")[0];
    s && s.querySelectorAll("a").forEach(function(i) {
      const o = i.getAttribute("href");
      if (!o)
        return;
      const r = new URL(o, window.location.origin);
      r.searchParams.set("vorm", t || ""), i.setAttribute("href", r.toString());
    });
  }
  fillMainDimensionInput(e) {
    let t = !1, s = !1, i;
    switch (e) {
      case this.options.shapeInputSelectors.Diameter:
        i = document.querySelector(this.options.shapeInputSelectors.Diameter).value, t = !0, s = !0;
        break;
      case this.options.shapeInputSelectors.WidthLeft:
      case this.options.shapeInputSelectors.WidthRight:
        i = 0, document.querySelectorAll(this.options.shapeInputSelectors.WidthLeft + ", " + this.options.shapeInputSelectors.WidthRight).forEach((a) => {
          i += parseFloat(a.value);
        }), s = !0;
        break;
      case this.options.shapeInputSelectors.HeightLeft:
      case this.options.shapeInputSelectors.HeightRight:
        i = 0, document.querySelectorAll(this.options.shapeInputSelectors.HeightLeft + ", " + this.options.shapeInputSelectors.HeightRight).forEach((a) => {
          const c = parseFloat(a.value);
          c > i && (i = c);
        }), t = !0;
        break;
      case this.options.shapeInputSelectors.Height:
        i = document.querySelector(this.options.shapeInputSelectors.Height).value, t = !0;
        break;
    }
    if (!t && !s)
      return;
    let o = [];
    t && o.push(this.options.shapeInputSelectors.Length), s && o.push(this.options.shapeInputSelectors.Width), document.querySelectorAll(o.join(",")).forEach((r) => {
      const h = r;
      h.value = i.toString(), h.dispatchEvent(new Event("input")), h.dispatchEvent(new Event("change"));
    });
  }
  /**
   * Check if the shape icons are already inserted otherwise insert the html after the footer tag
   * The svg icons are stored in icons.html
   * @private
   */
  insertShapeIcons() {
    var s;
    if (document.querySelector("#plexi-designer-icons"))
      return;
    const t = document.createElement("div");
    t.id = "plexi-designer-icons", t.style.visibility = "hidden", t.style.position = "absolute", t.style.width = "0", t.style.height = "0", t.innerHTML = `<svg id="plexi-designer-rectangle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53 42"><g id="Rectangle_877" data-name="Rectangle 877" fill="rgba(16,83,106,0.1)" stroke="#10536a" stroke-width="2.5"><rect width="53" height="42" stroke="none"/><rect x="1.25" y="1.25" width="50.5" height="39.5" fill="none"/></g></svg>
<svg id="plexi-designer-rectangle-rounded" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53 48"><g id="Rectangle_754" data-name="Rectangle 754" fill="rgba(16,83,106,0.1)" stroke="#10536a" stroke-width="2.5"><rect width="53" height="48" rx="6" stroke="none"/><rect x="1.25" y="1.25" width="50.5" height="45.5" rx="4.75" fill="none"/></g></svg>
<svg id="plexi-designer-circle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53 53"><g id="Rectangle_742" data-name="Rectangle 742" fill="rgba(16,83,106,0.1)" stroke="#10536a" stroke-width="2.5"><rect width="53" height="53" rx="26.5" stroke="none"/><rect x="1.25" y="1.25" width="50.5" height="50.5" rx="25.25" fill="none"/></g></svg>
<svg id="plexi-designer-semi-circle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51.999 27"><g id="Subtraction_4" data-name="Subtraction 4" fill="rgba(16,83,106,0.1)"><path d="M 50.74807739257812 25.75007629394531 L 1.251233100891113 25.74912452697754 C 1.283145070075989 22.49590682983398 1.936498999595642 19.34078216552734 3.194470882415771 16.36660957336426 C 4.440970897674561 13.41953945159912 6.225720882415771 10.77252960205078 8.499120712280273 8.499109268188477 C 10.7725305557251 6.225719451904297 13.41954135894775 4.440969467163086 16.36661148071289 3.194469690322876 C 19.41712188720703 1.904209613800049 22.65829086303711 1.249999642372131 26.00010108947754 1.249999642372131 C 29.34169006347656 1.249999642372131 32.58267974853516 1.904209613800049 35.63305282592773 3.194459676742554 C 38.58000946044922 4.440969467163086 41.22693252563477 6.225709438323975 43.50028991699219 8.499109268188477 C 45.7736701965332 10.77254962921143 47.55838012695312 13.41955947875977 48.80484008789062 16.36660003662109 C 50.06288146972656 19.34095764160156 50.71624374389648 22.49664115905762 50.74807739257812 25.75007629394531 Z" stroke="none"/><path d="M 49.45265579223633 24.50005149841309 C 49.28751373291016 21.85636138916016 48.68440628051758 19.29069137573242 47.65357971191406 16.85352897644043 C 46.47014236450195 14.0554895401001 44.7753791809082 11.54202938079834 42.61640167236328 9.382979393005371 C 40.45743179321289 7.223979473114014 37.94406127929688 5.529189586639404 35.14609909057617 4.345709800720215 C 32.25064086914062 3.120989561080933 29.17348098754883 2.499999523162842 26.00010108947754 2.499999523162842 C 22.82649040222168 2.499999523162842 19.74914169311523 3.120989561080933 16.85355186462402 4.345719814300537 C 14.05548095703125 5.529209613800049 11.54202079772949 7.223999500274658 9.383001327514648 9.382989883422852 C 7.224000930786133 11.54201984405518 5.529211044311523 14.05548000335693 4.345720767974854 16.85354995727539 C 3.315046072006226 19.29034042358398 2.711946487426758 21.85586547851562 2.546703100204468 24.49914932250977 L 49.45265579223633 24.50005149841309 M 51.99930191040039 27.00009918212891 L 9.552002211421495e-07 26.99909973144531 L 9.552002211421495e-07 26.00009918212891 C 9.552002211421495e-07 22.49009895324707 0.6874309778213501 19.0851001739502 2.043210983276367 15.87966918945312 C 3.352741003036499 12.78359985351562 5.22744083404541 10.00303936004639 7.615231037139893 7.615229606628418 C 10.00304126739502 5.227439403533936 12.78360080718994 3.352739572525024 15.87967109680176 2.043209552764893 C 19.0851001739502 0.6874296069145203 22.4901008605957 -4.089355343239731e-07 26.00010108947754 -4.089355343239731e-07 C 29.50988006591797 -4.089355343239731e-07 32.91471099853516 0.6874296069145203 36.12001037597656 2.043209552764893 C 39.21596145629883 3.352739572525024 41.99642944335938 5.227439403533936 44.38418197631836 7.615229606628418 C 46.77194213867188 10.00305938720703 48.64661026000977 12.78360939025879 49.95610046386719 15.87966918945312 C 51.31187057495117 19.0850887298584 51.99930191040039 22.49009895324707 51.99930191040039 26.00009918212891 L 51.99930191040039 27.00009918212891 Z" stroke="none" fill="#10536a"/></g></svg>
<svg id="plexi-designer-arch" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51.999 52"><g id="Union_1" data-name="Union 1" fill="rgba(16,83,106,0.1)"><path d="M 50.74930191040039 50.75020217895508 L 1.250000953674316 50.75020217895508 L 1.250000953674316 25.57195663452148 L 1.264310956001282 25.14563179016113 C 1.366290926933289 22.10700035095215 2.015610933303833 19.15361022949219 3.194231033325195 16.36751174926758 C 4.440351009368896 13.42049121856689 6.225040912628174 10.77343082427979 8.498781204223633 8.49968147277832 C 10.77190113067627 6.226561069488525 13.41900062561035 4.441861152648926 16.36654090881348 3.195161104202271 C 19.41735076904297 1.904431104660034 22.65851020812988 1.250001072883606 26.00010108947754 1.250001072883606 C 29.34169006347656 1.250001072883606 32.58285140991211 1.904431104660034 35.63355255126953 3.195111036300659 C 38.58016967773438 4.441421031951904 41.22695922851562 6.226130962371826 43.50052261352539 8.49968147277832 C 45.77426147460938 10.77343082427979 47.55895233154297 13.42049121856689 48.80499267578125 16.3673210144043 C 49.98374176025391 19.15451049804688 50.63307189941406 22.10793113708496 50.73498916625977 25.14562034606934 L 50.74930191040039 25.57205390930176 L 50.74930191040039 25.99920082092285 L 50.74930191040039 50.75020217895508 Z" stroke="none"/><path d="M 49.49930191040039 49.50020217895508 L 49.49930191040039 25.59290885925293 L 49.48570251464844 25.18753051757812 C 49.38893127441406 22.30351066589355 48.77257919311523 19.49980163574219 47.65369033813477 16.85414123535156 C 46.47066116333008 14.05635070800781 44.77595138549805 11.54289150238037 42.61663055419922 9.383570671081543 C 40.45746994018555 7.224400997161865 37.94422912597656 5.529661178588867 35.14649963378906 4.346321105957031 C 32.25075149536133 3.121191024780273 29.1734504699707 2.500001192092896 26.00010108947754 2.500001192092896 C 22.82675170898438 2.500001192092896 19.74945068359375 3.121191024780273 16.85348129272461 4.346411228179932 C 14.05494117736816 5.530101299285889 11.54139137268066 7.224841117858887 9.382671356201172 9.383570671081543 C 7.223351001739502 11.54289150238037 5.528640747070312 14.05635070800781 4.345450878143311 16.85452079772949 C 3.22675085067749 19.49899101257324 2.610430955886841 22.30263137817383 2.513601064682007 25.18756103515625 L 2.500000953674316 25.59278297424316 L 2.500000953674316 49.50020217895508 L 49.49930191040039 49.50020217895508 M 51.99930191040039 52.00020217895508 L 9.552002211421495e-07 52.00020217895508 L 9.552002211421495e-07 25.10370063781738 L 0.01501095481216908 25.10370063781738 C 0.1222109571099281 21.90958023071289 0.8032509684562683 18.81111145019531 2.043000936508179 15.88050079345703 C 3.352500915527344 12.78360080718994 5.227200984954834 10.00350093841553 7.614901065826416 7.615800857543945 C 10.00260066986084 5.228101253509521 12.78360080718994 3.353401184082031 15.87960052490234 2.043901205062866 C 19.08540153503418 0.6876010894775391 22.4901008605957 1.089477564164554e-06 26.00010108947754 1.089477564164554e-06 C 29.51010131835938 1.089477564164554e-06 32.91480255126953 0.6876010894775391 36.12060165405273 2.043901205062866 C 39.21660232543945 3.353401184082031 41.99670028686523 5.228101253509521 44.3843994140625 7.615800857543945 C 46.77210235595703 10.00350093841553 48.64680099487305 12.78360080718994 49.95630264282227 15.88050079345703 C 51.19613265991211 18.81213188171387 51.87715911865234 21.91073036193848 51.98429107666016 25.10370063781738 L 51.99930191040039 25.10370063781738 L 51.99930191040039 52.00020217895508 Z" stroke="none" fill="#10536a"/></g></svg>
<svg id="plexi-designer-triangle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52.27 45.06"><g id="Path_1382" data-name="Path 1382" transform="translate(0 -8)" fill="rgba(16,83,106,0.1)"><path d="M 50.09985733032227 51.81025314331055 L 2.170041799545288 51.81025314331055 L 26.13494491577148 10.49144744873047 L 50.09985733032227 51.81025314331055 Z" stroke="none"/><path d="M 26.13494491577148 12.98287963867188 L 4.340068817138672 50.56024551391602 L 47.9298095703125 50.56024551391602 L 26.13494491577148 12.98287963867188 M 26.13494491577148 7.999996185302734 L 52.2698860168457 53.06024551391602 L -3.814697265625e-06 53.06024551391602 L 26.13494491577148 7.999996185302734 Z" stroke="none" fill="#10536a"/></g></svg>
<svg id="plexi-designer-hexagon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53 45"><g id="Polygon_2" data-name="Polygon 2" fill="rgba(16,83,106,0.1)"><path d="M 39.03546905517578 43.75 L 13.96453094482422 43.75 L 1.450642228126526 22.5 L 13.96453094482422 1.25 L 39.03546905517578 1.25 L 51.54935836791992 22.5 L 39.03546905517578 43.75 Z" stroke="none"/><path d="M 14.67906188964844 2.5 L 2.901283264160156 22.5 L 14.67906188964844 42.5 L 38.32093811035156 42.5 L 50.09871673583984 22.5 L 38.32093811035156 2.5 L 14.67906188964844 2.5 M 13.25 0 L 39.75 0 L 53 22.5 L 39.75 45 L 13.25 45 L 0 22.5 L 13.25 0 Z" stroke="none" fill="#10536a"/></g></svg>
<svg id="plexi-designer-trapezoid" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52.27 45.06"><g id="Path_1383" data-name="Path 1383" transform="translate(0 -10)" fill="rgba(16,83,106,0.1)"><path d="M 50.74513626098633 53.81024169921875 L 1.524762630462646 53.81024169921875 L 10.03680324554443 11.25000095367432 L 42.23307418823242 11.25000095367432 L 50.74513626098633 53.81024169921875 Z" stroke="none"/><path d="M 11.06155395507812 12.5 L 3.049503326416016 52.56024169921875 L 49.22037506103516 52.56024169921875 L 41.20832824707031 12.5 L 11.06155395507812 12.5 M 9.012046813964844 10 L 43.25783538818359 10 L 52.2698860168457 55.06024169921875 L -3.814697265625e-06 55.06024169921875 L 9.012046813964844 10 Z" stroke="none" fill="#10536a"/></g></svg>
<svg id="plexi-designer-rectangle-slanted-side" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52.27 36.048"><g id="Path_1384" data-name="Path 1384" fill="rgba(16,83,106,0.1)"><path d="M 51.01989364624023 34.79819869995117 L 1.250004887580872 34.79819869995117 L 1.250004887580872 1.483961939811707 L 51.01989364624023 10.06497764587402 L 51.01989364624023 34.79819869995117 Z" stroke="none"/><path d="M 2.499996185302734 2.967918395996094 L 2.499996185302734 33.54819869995117 L 49.7698860168457 33.54819869995117 L 49.7698860168457 11.11789894104004 L 2.499996185302734 2.967918395996094 M -3.814697265625e-06 -3.814697265625e-06 L 52.2698860168457 9.012046813964844 L 52.2698860168457 36.04819869995117 L -3.814697265625e-06 36.04819869995117 L -3.814697265625e-06 -3.814697265625e-06 Z" stroke="none" fill="#10536a"/></g></svg>
<svg id="plexi-designer-diamond" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53 36"><g id="Polygon_3" data-name="Polygon 3" fill="rgba(16,83,106,0.1)"><path d="M 26.5 34.48891067504883 L 2.224657297134399 18 L 26.5 1.511087894439697 L 50.77534103393555 18 L 26.5 34.48891067504883 Z" stroke="none"/><path d="M 26.5 3.022182464599609 L 4.449325561523438 18 L 26.5 32.97781753540039 L 48.55067443847656 18 L 26.5 3.022182464599609 M 26.5 0 L 53 18 L 26.5 36 L 0 18 L 26.5 0 Z" stroke="none" fill="#10536a"/></g></svg>`, (s = document.querySelector("body")) == null || s.append(t);
  }
  clearInputValues() {
    Object.values(this.options.shapeInputSelectors || {}).forEach((e) => {
      document.querySelectorAll(e).forEach((t) => {
        const s = t;
        s.value = "", s.dispatchEvent(new Event("input")), s.dispatchEvent(new Event("change"));
      });
    });
  }
}
export {
  ct as PlexiDesigner
};
